import React from 'react';

export default function About() {
  return (
    <section style={{
      background: '#FDFCFF',
      padding: '3.5rem 0',
    }}>
      <div className="content-column">
        <div className="section-tag">About</div>

        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '1.75rem',
          lineHeight: 1.2,
          color: '#1A1530',
          marginTop: 0,
          marginBottom: '1.1rem',
        }}>
          Hi, I'm your local{' '}
          <em style={{ fontWeight: 400, color: '#7B6EC4' }}>assistant</em>
        </h2>

        <div style={{ maxWidth: '640px' }}>
          <p style={{
            fontSize: '0.93rem',
            fontWeight: 300,
            color: '#55437a',
            lineHeight: 1.75,
            marginTop: 0,
            marginBottom: '0.85rem',
          }}>
            I'm based in Sumner — been part of the community for years now, enjoying the surf and the good life by the hills.
          </p>

          <p style={{
            fontSize: '0.93rem',
            fontWeight: 300,
            color: '#5a497d',
            lineHeight: 1.75,
            marginTop: 0,
            marginBottom: '0.85rem',
          }}>
            I'm an engineer by background, with years in data analytics, health and safety on hazardous substances, and process improvement. Currently I'm taking a deliberate step into full-stack development and AI engineering, and while I do that, I'm putting my energy into helping the people around me.
          </p>

          <p style={{
            fontSize: '0.93rem',
            fontWeight: 300,
            color: '#463175',
            lineHeight: 1.75,
            marginTop: 0,
            marginBottom: '1.5rem',
          }}>
            I'm also a dog owner — a large girl, and I trained her through a professional trainer who literally trained <em>me</em> to train my dog. So if yours is a big one, you can trust they'll be in good hands.
          </p>

          {/* Credentials */}
          <div style={{
            background: '#F5F2FF',
            borderRadius: '1rem',
            padding: '1.25rem',
            border: '0.5px solid #E8E0F0',
          }}>
            <div style={{
              fontWeight: 600,
              fontSize: '0.85rem',
              color: '#1A1530',
              marginBottom: '0.75rem',
            }}>
              Things worth knowing
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.45rem',
            }}>
              {[
                'Engineer (Engineering New Zealand member)',
                'Full NZ driver\'s licence',
                'First Aid certified',
                'Fire Warden trained',
                'Clean Ministry of Justice criminal record (happy to share on request)',
                'References from the community on request',
              ].map((item) => (
                <div key={item} style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '0.5rem',
                  fontSize: '0.85rem',
                  color: '#3b2271',
                  fontWeight: 300,
                }}>
                  <span style={{ color: '#7B6EC4', fontWeight: 600, flexShrink: 0, marginTop: '0.05rem' }}>✓</span>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
